import { AxiosPromise } from 'axios';
import { ApiResponseEntity, CompanyDTO } from 'types';
import axios from 'utils/axios';

const API_PATH = "/company";

export default class CompanyApi {
    static getCompany(id: number): AxiosPromise<ApiResponseEntity<CompanyDTO>> {
        return axios.get(`${API_PATH}/${id}`);
    }

    static getAllCompanies(): AxiosPromise<ApiResponseEntity<CompanyDTO[]>> {
        return axios.get(API_PATH);
    }
}